/* eslint-disable react/prop-types */
import React, { useState } from "react";

import { allDeviceTypeOption, colors, strCode } from "../../../consts";
import { deviceUtil, fwuVersionsUtil } from "../../../utils";

import {
  WrapperContainer,
  TextOverflowWrapper,
  GradientLoader,
  FlexContainers,
  DeviceInfo
} from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";
import { BinFile, SignatureFile } from "./components/TableColumnsComponents";
import ControlButtons from "./components/TableColumnsComponents/ControlButtons";

const isNewRow = (cell) => {
  return cell.row.original.isNew;
};

const isEditable = (record) => {
  return !record?.binFile || !record?.signatureFile;
};

const deviceFilter = (rows, id, filterValue) => {
  return rows.filter((row) => {
    const value = row.values[id];

    return (
      !value ||
      ((!filterValue.model ||
        filterValue.model.length === 0 ||
        filterValue.model.includes(value)) &&
        (!filterValue.type ||
          filterValue.type === allDeviceTypeOption.id ||
          deviceUtil.getDeviceType(value).includes(filterValue.type)))
    );
  });
};

export const FirmwaresTableColumns = [
  {
    Header: strCode.VERSION_TITLE,
    accessor: "fwuName",
    sortType: "fwuIsNew",
    Cell: ({ cell, isLoading, searchedText, cellWidth10 }) => {
      const record = cell.row.original;

      return (
        <CellWrapper width={`${cellWidth10}px`} style={{ position: "relative" }}>
          {isLoading ? (
            <GradientLoader width={120} height={24} animationDuration={40} />
          ) : (
            <TextOverflowWrapper maxWidth={cellWidth10 / 2} highlightedText={searchedText}>
              {record.fwuName}
            </TextOverflowWrapper>
          )}
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.DEVICE_TITLE,
    accessor: "model",
    filter: deviceFilter,
    Cell: ({ cell, isLoading, cellWidth5 }) => {
      const [isImageLoaded, setIsImageLoaded] = useState(false);
      const [deviceImage, setDeviceImage] = useState();

      const record = cell?.row?.original;

      deviceUtil.getDeviceImageAssetByType(record?.model, record?.deviceType).then((res) => {
        setDeviceImage(res);
      });

      return (
        <CellWrapper width={`${cellWidth5}px`}>
          <DeviceInfo
            isLoading={isLoading}
            isImageLoaded={isImageLoaded}
            setIsImageLoaded={setIsImageLoaded}
            imageSrc={deviceImage}
            model={record.model}
            type={record.deviceType}
            width={cellWidth5}
          />
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.BIN_FILE_TITLE,
    accessor: "binFile",
    Cell: ({ cell, isLoading, cellWidth8 }) => {
      const record = cell.row.original;
      const isNew = isNewRow(cell);

      const hasBinFile = record?.binFile;

      return (
        <CellWrapper width={`${cellWidth8}px`}>
          {
            <>
              {isLoading ? (
                <GradientLoader width={cellWidth8} height={24} animationDuration={40} />
              ) : isNew || !hasBinFile ? (
                <BinFile fwuVersion={record} isNewRow={isNew} />
              ) : cell.value ? (
                <TextOverflowWrapper maxWidth={cellWidth8}>{cell.value?.name}</TextOverflowWrapper>
              ) : null}
            </>
          }
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.SIGNATURE_FILE_TITLE,
    accessor: "signatureFile",
    Cell: ({ cell, isLoading, cellWidth8 }) => {
      const record = cell.row.original;
      const isNew = isNewRow(cell);

      const hasSignatureFile = record?.signatureFile;

      return (
        <CellWrapper width={`${cellWidth8}px`}>
          {
            <>
              {isLoading ? (
                <GradientLoader width={cellWidth8} height={24} animationDuration={40} />
              ) : isNew || !hasSignatureFile ? (
                <SignatureFile fwuVersion={record} isNewRow={isNew} />
              ) : cell.value ? (
                <TextOverflowWrapper maxWidth={cellWidth8}>{cell.value?.name}</TextOverflowWrapper>
              ) : null}
            </>
          }
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.OWNER_TITLE,
    accessor: "createdBy",
    Cell: ({ cell, isLoading, cellWidth8 }) => {
      const { createdBy, createdAt } = cell?.value ?? {};

      return (
        <CellWrapper width={`${cellWidth8}px`}>
          {
            <WrapperContainer
              width={`${cellWidth8}px`}
              Container={FlexContainers.FlexColumn}
              gap={4}
              alignItems="start">
              <TextOverflowWrapper maxWidth={`${cellWidth8}px`} style={{ color: colors.RAISIN_70 }}>
                {isLoading ? (
                  <GradientLoader width={cellWidth8} height={24} animationDuration={40} />
                ) : (
                  createdBy
                )}
              </TextOverflowWrapper>

              <TextOverflowWrapper
                maxWidth={`${cellWidth8}px`}
                style={{ color: colors.RAISIN_70, fontSize: "14px" }}>
                {isLoading ? (
                  <GradientLoader width={cellWidth8} height={24} animationDuration={40} />
                ) : (
                  createdAt
                )}
              </TextOverflowWrapper>
            </WrapperContainer>
          }
        </CellWrapper>
      );
    }
  },
  {
    id: "control-buttons",
    Cell: ({
      cell,
      isValid,
      isLoading,
      callbackFn1: onUpdateFWUVersion,
      callbackFn2: onDeleteFirmwareVersion,
      callbackFn4: onEditFirmwareVersion
    }) => {
      const record = cell.row.original;
      const isNew = record.isNew;
      const isEditing = fwuVersionsUtil.isVersionToEdit(record);

      return (
        <CellWrapper>
          <WrapperContainer Container={FlexContainers.FlexRowCenter} width={"100%"}>
            <ControlButtons
              fwuVersion={record}
              isLoading={isLoading}
              isValid={isValid}
              isEditable={isEditable(record)}
              isNewRow={isNew}
              isEditingRow={isEditing}
              onDeleteFirmwareVersion={onDeleteFirmwareVersion}
              onEditFirmwareVersion={onEditFirmwareVersion}
              onFinish={onUpdateFWUVersion}
            />
          </WrapperContainer>
        </CellWrapper>
      );
    }
  }
];
